import { useNavigate, useRouter } from '@tanstack/react-router'
import { cn } from '@/lib/utils'
import { AlertTriangle } from 'lucide-react'

interface GeneralErrorProps extends React.HTMLAttributes<HTMLDivElement> {
  minimal?: boolean
}

export default function GeneralError({
  className,
  minimal = false,
}: GeneralErrorProps) {
  const navigate = useNavigate()
  const { history } = useRouter()

  return (
    <div className={cn('flex h-svh w-full items-center justify-center bg-muted', className)}>
      <div className='w-full max-w-[420px] rounded-2xl bg-white p-10 text-center shadow-[0_4px_30px_rgba(0,0,0,0.024)]'>
        {!minimal && (
          <div className='mb-4 flex justify-center'>
            <AlertTriangle className='h-12 w-12 text-ring' />
          </div>
        )}
        {!minimal && (
          <h1
            className='mb-1 text-[64px] font-medium leading-none tracking-[-2px] text-sidebar-foreground'
            style={{ fontFamily: 'Fraunces, Georgia, serif' }}
          >
            500
          </h1>
        )}
        <p
          className='mb-2 text-lg font-medium text-sidebar-foreground'
          style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}
        >
          Something went wrong
        </p>
        <p
          className='mb-8 text-sm text-muted-foreground'
          style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}
        >
          We apologize for the inconvenience.
          Please try again later.
        </p>
        {!minimal && (
          <div className='flex gap-3'>
            <button
              onClick={() => history.go(-1)}
              className='flex-1 rounded-md border-[1.5px] border-sidebar-border bg-white px-4 py-3 text-sm font-medium text-sidebar-foreground transition-colors hover:bg-background'
              style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}
            >
              Go Back
            </button>
            <button
              onClick={() => navigate({ to: '/' })}
              className='flex-1 rounded-md bg-sidebar-primary px-4 py-3 text-sm font-bold text-white transition-colors hover:bg-sidebar-primary/90'
              style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}
            >
              Back to Home
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
